export default __webpack_public_path__ + "static/media/car-hybrid.dc4d349a.svg";